import * as ambassadorWixPaymentlinksPaymentsV1PaymentLinkPayment from './paymentlinks-payments-v1-payment-link-payment-payment-link-payments.http.js';
import * as ambassadorWixPaymentlinksPaymentsV1PaymentLinkPaymentTypes from './paymentlinks-payments-v1-payment-link-payment-payment-link-payments.types.js';
import * as ambassadorWixPaymentlinksPaymentsV1PaymentLinkPaymentUniversalTypes from './paymentlinks-payments-v1-payment-link-payment-payment-link-payments.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function queryPaymentLinkPayments(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPaymentlinksPaymentsV1PaymentLinkPaymentUniversalTypes.QueryPaymentLinkPaymentsRequest,
  ambassadorWixPaymentlinksPaymentsV1PaymentLinkPaymentTypes.QueryPaymentLinkPaymentsRequest,
  ambassadorWixPaymentlinksPaymentsV1PaymentLinkPaymentUniversalTypes.QueryPaymentLinkPaymentsResponse,
  ambassadorWixPaymentlinksPaymentsV1PaymentLinkPaymentTypes.QueryPaymentLinkPaymentsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPaymentlinksPaymentsV1PaymentLinkPayment.queryPaymentLinkPayments(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/payment-link-payments/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function searchPaymentLinkPayments(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPaymentlinksPaymentsV1PaymentLinkPaymentUniversalTypes.SearchPaymentLinkPaymentsRequest,
  ambassadorWixPaymentlinksPaymentsV1PaymentLinkPaymentTypes.SearchPaymentLinkPaymentsRequest,
  ambassadorWixPaymentlinksPaymentsV1PaymentLinkPaymentUniversalTypes.SearchPaymentLinkPaymentsResponse,
  ambassadorWixPaymentlinksPaymentsV1PaymentLinkPaymentTypes.SearchPaymentLinkPaymentsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPaymentlinksPaymentsV1PaymentLinkPayment.searchPaymentLinkPayments(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/payment-link-payments/search',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function issueReceipt(): __PublicMethodMetaInfo<
  'POST',
  { paymentLinkPaymentId: string },
  ambassadorWixPaymentlinksPaymentsV1PaymentLinkPaymentUniversalTypes.IssueReceiptRequest,
  ambassadorWixPaymentlinksPaymentsV1PaymentLinkPaymentTypes.IssueReceiptRequest,
  ambassadorWixPaymentlinksPaymentsV1PaymentLinkPaymentUniversalTypes.IssueReceiptResponse,
  ambassadorWixPaymentlinksPaymentsV1PaymentLinkPaymentTypes.IssueReceiptResponse
> {
  const payload = { paymentLinkPaymentId: ':paymentLinkPaymentId' } as any;

  const getRequestOptions =
    ambassadorWixPaymentlinksPaymentsV1PaymentLinkPayment.issueReceipt(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/payment-link-payments/{paymentLinkPaymentId}/issue-receipt',
    pathParams: { paymentLinkPaymentId: 'paymentLinkPaymentId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  PaymentLinkPayment as PaymentLinkPaymentOriginal,
  PaymentLinkPaymentPaymentOneOf as PaymentLinkPaymentPaymentOneOfOriginal,
  PaymentLinkPaymentEcomCheckoutTypeOneOf as PaymentLinkPaymentEcomCheckoutTypeOneOfOriginal,
  PaymentLinkPaymentCheckoutTypeOneOf as PaymentLinkPaymentCheckoutTypeOneOfOriginal,
  PaymentLinkPaymentType as PaymentLinkPaymentTypeOriginal,
  PaymentLinkPaymentTypeWithLiterals as PaymentLinkPaymentTypeWithLiteralsOriginal,
  RegularPaymentLinkPayment as RegularPaymentLinkPaymentOriginal,
  RegularPaymentLinkPaymentPaymentMethodDataOneOf as RegularPaymentLinkPaymentPaymentMethodDataOneOfOriginal,
  FullAddressContactDetails as FullAddressContactDetailsOriginal,
  VatId as VatIdOriginal,
  VatType as VatTypeOriginal,
  VatTypeWithLiterals as VatTypeWithLiteralsOriginal,
  Address as AddressOriginal,
  AddressStreetOneOf as AddressStreetOneOfOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  Subdivision as SubdivisionOriginal,
  SubdivisionType as SubdivisionTypeOriginal,
  SubdivisionTypeWithLiterals as SubdivisionTypeWithLiteralsOriginal,
  PaymentMethod as PaymentMethodOriginal,
  PaymentMethodWithLiterals as PaymentMethodWithLiteralsOriginal,
  CreditCardPaymentMethodData as CreditCardPaymentMethodDataOriginal,
  WalletPaymentMethodData as WalletPaymentMethodDataOriginal,
  PaymentOrder as PaymentOrderOriginal,
  PaymentOrderTypeDetailsOneOf as PaymentOrderTypeDetailsOneOfOriginal,
  OrderType as OrderTypeOriginal,
  OrderTypeWithLiterals as OrderTypeWithLiteralsOriginal,
  Ecom as EcomOriginal,
  Cashier as CashierOriginal,
  GiftCardPaymentLinkPayment as GiftCardPaymentLinkPaymentOriginal,
  StandardCheckout as StandardCheckoutOriginal,
  LeanCheckout as LeanCheckoutOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  EcomCheckout as EcomCheckoutOriginal,
  EcomOrderCheckout as EcomOrderCheckoutOriginal,
  QueryPaymentLinkPaymentsRequest as QueryPaymentLinkPaymentsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryPaymentLinkPaymentsResponse as QueryPaymentLinkPaymentsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  SearchPaymentLinkPaymentsRequest as SearchPaymentLinkPaymentsRequestOriginal,
  CursorSearch as CursorSearchOriginal,
  CursorSearchPagingMethodOneOf as CursorSearchPagingMethodOneOfOriginal,
  Aggregation as AggregationOriginal,
  AggregationKindOneOf as AggregationKindOneOfOriginal,
  RangeBucket as RangeBucketOriginal,
  SortType as SortTypeOriginal,
  SortTypeWithLiterals as SortTypeWithLiteralsOriginal,
  SortDirection as SortDirectionOriginal,
  SortDirectionWithLiterals as SortDirectionWithLiteralsOriginal,
  MissingValues as MissingValuesOriginal,
  MissingValuesWithLiterals as MissingValuesWithLiteralsOriginal,
  IncludeMissingValuesOptions as IncludeMissingValuesOptionsOriginal,
  ScalarType as ScalarTypeOriginal,
  ScalarTypeWithLiterals as ScalarTypeWithLiteralsOriginal,
  ValueAggregation as ValueAggregationOriginal,
  ValueAggregationOptionsOneOf as ValueAggregationOptionsOneOfOriginal,
  NestedAggregationType as NestedAggregationTypeOriginal,
  NestedAggregationTypeWithLiterals as NestedAggregationTypeWithLiteralsOriginal,
  RangeAggregation as RangeAggregationOriginal,
  ScalarAggregation as ScalarAggregationOriginal,
  DateHistogramAggregation as DateHistogramAggregationOriginal,
  Interval as IntervalOriginal,
  IntervalWithLiterals as IntervalWithLiteralsOriginal,
  NestedAggregationItem as NestedAggregationItemOriginal,
  NestedAggregationItemKindOneOf as NestedAggregationItemKindOneOfOriginal,
  AggregationType as AggregationTypeOriginal,
  AggregationTypeWithLiterals as AggregationTypeWithLiteralsOriginal,
  NestedAggregation as NestedAggregationOriginal,
  SearchDetails as SearchDetailsOriginal,
  Mode as ModeOriginal,
  ModeWithLiterals as ModeWithLiteralsOriginal,
  SearchPaymentLinkPaymentsResponse as SearchPaymentLinkPaymentsResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  AggregationData as AggregationDataOriginal,
  ValueAggregationResult as ValueAggregationResultOriginal,
  RangeAggregationResult as RangeAggregationResultOriginal,
  NestedAggregationResults as NestedAggregationResultsOriginal,
  NestedAggregationResultsResultOneOf as NestedAggregationResultsResultOneOfOriginal,
  ValueResults as ValueResultsOriginal,
  RangeResults as RangeResultsOriginal,
  AggregationResultsScalarResult as AggregationResultsScalarResultOriginal,
  NestedValueAggregationResult as NestedValueAggregationResultOriginal,
  ValueResult as ValueResultOriginal,
  RangeResult as RangeResultOriginal,
  ScalarResult as ScalarResultOriginal,
  NestedResultValue as NestedResultValueOriginal,
  NestedResultValueResultOneOf as NestedResultValueResultOneOfOriginal,
  Results as ResultsOriginal,
  DateHistogramResult as DateHistogramResultOriginal,
  GroupByValueResults as GroupByValueResultsOriginal,
  DateHistogramResults as DateHistogramResultsOriginal,
  NestedResults as NestedResultsOriginal,
  AggregationResults as AggregationResultsOriginal,
  AggregationResultsResultOneOf as AggregationResultsResultOneOfOriginal,
  IssueReceiptRequest as IssueReceiptRequestOriginal,
  IssueReceiptResponse as IssueReceiptResponseOriginal,
  BulkUpsertPaymentLinkPaymentsRequest as BulkUpsertPaymentLinkPaymentsRequestOriginal,
  BulkUpsertPaymentLinkPaymentsResponse as BulkUpsertPaymentLinkPaymentsResponseOriginal,
  Empty as EmptyOriginal,
  AccountInfo as AccountInfoOriginal,
  IssueReceiptApplicationErrors as IssueReceiptApplicationErrorsOriginal,
} from './paymentlinks-payments-v1-payment-link-payment-payment-link-payments.types.js';
